export enum OperateButton {
  BlueShort = 'blue-short',
  BlueLong = 'blue-long',
  Short = 'short',
  Long = 'long'
}

export enum ButtonSVGType {
  Normal = 'normal',
  Blue = 'blue'
}

export type ButtonSVGProps = {
  style?: ButtonSVGType
}

export const blueColorScheme = {
  pathFill: '#005BD7',
  pathStroke: '',
  rectFill: '#0354C2',
  rectStroke: '#4894FC',
  smallRectFill: '#0E4591'
}

export const normalShortColorScheme = {
  pathFill: '#74726C',
  pathStroke: '#C6AF8F',
  rectFill: '#414141',
  rectStroke: '#696664',
  smallRectFill: ''
}

export const normalLongColorScheme = {
  pathFill: '#74726C',
  pathStroke: '#C6AF8F',
  rectFill: '#414141',
  rectStroke: '#696664',
  smallRectFill: '#282828'
}
